import { useState } from "react";

import { DUT_ACCORDION_SECTIONS } from "../NewDutFlow/constants";

import NewDutAccordionItem from "../NewDutFlow/NewDutAccordionItem";
import GeneralFindingsFormAi from "./GeneralFindingsFormAi";
import FamilyHistoryFormAi from "./FamilyHistoryFormAi";
import PersonalHistoryFormAi from "./PersonalHistoryFormAi";
import AdmissionDetailsFormAi from "./AdmissionDetailsFormAi";
import DiagnosisFormAi from "./DiagnosisFormAi";
import TreatmentPlanAi from "./TreatmentPlanAi";
import CareTeamDetailsFormAi from "./CareTeamDetailsFormAi";
import ImplantsFormAi from "./ImplantsFormAi";
import STGQuestionnaireFormAi from "./STGQuestionnaireFormAi";
import InvestigationDocumentsFormAi from "./InvestigationDocumentsFormAi";
// import HospitalBillDetailsFormAi from "./forms/HospitalBillDetailsFormAi";
// import ClaimQueryDetailsFormAi from "./forms/ClaimQueryDetailsFormAi";
// import EnhancementTreatmentPlanAi from "./forms/AmountandIncentiveDetailsAi";
// import AmountandIncentiveDetailsAi from "./forms/AmountandIncentiveDetailsAi";
// import { CaseStageContext } from "../dashboard/cases/contexts/CaseContexts";

const NewDutAccordionAi = ({ dutData, showAll, saveAll }) => {
  //   const { caseStage, setCaseStage } = useContext(CaseStageContext);
  const visibleSections = DUT_ACCORDION_SECTIONS.filter((section) => {
    // if (
    //   section.id === "implants" &&
    //   (!dutData?.treatment?.implants || dutData.treatment.implants.length === 0)
    // ) {
    //   return false;
    // }

    return section?.caseStage?.toLowerCase()?.includes("admission");
  });
  const [expanded, setExpanded] = useState({
    "general-findings": true,
    "family-history": true,
    "personal-history": true,
    "admission-details": true,
    diagnosis: true,
    "treatment-plan": true,
    implants: true,
    "investigation-documents": true,
    "care-team-details": true,
    "stg-questionnaire": true,
    "Amount-and-Incentive-Details": true,
    "hospital-details": true,
    "claim-query-details": true,
    // "enhancement-investigation-documents": true,
  });

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: isExpanded,
    }));
  };

  const renderAccordionContent = (id) => {
    switch (id) {
      case "general-findings":
        return <GeneralFindingsFormAi />;

      case "family-history":
        return <FamilyHistoryFormAi />;

      case "personal-history":
        return <PersonalHistoryFormAi />;

      case "admission-details":
        return <AdmissionDetailsFormAi />;

      case "diagnosis":
        return <DiagnosisFormAi />;

      case "treatment-plan":
        return <TreatmentPlanAi />;

      case "implants":
        return <ImplantsFormAi />;

      case "investigation-documents":
        return <InvestigationDocumentsFormAi />;

      case "care-team-details":
        return <CareTeamDetailsFormAi />;

      //   case "hospital-details":
      //     return (
      //       <HospitalBillDetailsFormAi
      //         data={dutData?.finance?.hospitalBillDetails}
      //         caseStage={"Discharge"}
      //       />
      //     );

      //   case "claim-query-details":
      //     return <ClaimQueryDetailsFormAi />;

      //   case "Amount-and-Incentive-Details":
      //     return <AmountandIncentiveDetailsAi />;

      case "stg-questionnaire":
        return <STGQuestionnaireFormAi />;

      default:
        return null;
    }
  };

  return (
    <div className="w-full flex justify-center  min-h-screen pt-[7px] rounded-[16px]">
      <div className="w-full flex flex-col gap-[8px]  3xl:px-[1px]  rounded-[16px]">
        {" "}
        {visibleSections.map((section) => (
          <NewDutAccordionItem
            key={section.id}
            title={section.title}
            expanded={expanded[section.id] || showAll}
            onChange={handleAccordionChange(section.id)}
            wrapperClassName={
              (section.id === "care-team-details" ||
                section.id === "implants") &&
              expanded[section.id]
                ? "overflow-visible"
                : ""
            }
          >
            {renderAccordionContent(section.id)}
          </NewDutAccordionItem>
        ))}
      </div>
    </div>
  );
};

export default NewDutAccordionAi;
